<template>
  <div :class="'swiper-container ' + noSwiperClass">
    <div class="swiper-wrapper">
      <div class="swiper-slide slide-1">
        <slot name="first-slide-content"></slot>
      </div>
      <div class="swiper-slide slide-2">
        <div class="swiper-container-sec">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <slot name="second-slide-content"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';

const defaultSwiperConfig = {
  direction: 'vertical',
  resistanceRatio: 0,
  slidesPerView: 'auto',
  noSwiping: true
};

export default {
  name: 'Swiper',
  components: {},
  props: {
    noSwiperClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      swiper1: null,
      swiper2: null
    };
  },
  created() { },
  computed: {},
  methods: {
    init(swiperConfig1 = {}, swiperConfig2 = {}) {
      this.swiper1 = new Swiper('.swiper-container', {
        ...defaultSwiperConfig,
        pagination: '.swiper-pagination-h',
        paginationClickable: true,
        mousewheelControl: true,
        // onInit: swiper => {  }
        ...swiperConfig1
      });
      this.swiper2 = new Swiper('.swiper-container-sec', {
        ...defaultSwiperConfig,
        nested: true,
        freeMode: true,
        freeModeMomentumBounce: false,
        autoHeight: true,
        observeParents: true,
        observer: true,
        ...swiperConfig2
      });
    },
    nextSwiper(activeIdx) {
      this.swiper1.slideTo(activeIdx, 500, true);
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/MySwiper/index.vue